import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../../../shared/api/axios-instance';
import { Endpoints } from '../../../../shared/utils/endpoints-file.utils';
import { ReplyRequestDto } from '../dtos/reply-request.dto';
import { ReplyRequestModel } from '../models/reply-request.model';
import { ReplyModel } from '../models/reply.model';
import { mapReplyRequestDtoToReplyRequestModel } from '../utils/mapping/mapping.util';

export const addReply: AsyncThunk<
  ReplyModel,
  ReplyRequestModel,
  Record<string, unknown>
> = createAsyncThunk<ReplyModel, ReplyRequestModel, Record<string, unknown>>(
  'reply/add-reply',
  async (replyBody): Promise<ReplyModel> => {
    const replyDto: ReplyRequestDto =
      mapReplyRequestDtoToReplyRequestModel(replyBody);

    const { data }: AxiosResponse<ReplyModel> = await axiosInstance.post(
      Endpoints.ADD_REPLY,
      replyDto,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return data;
  }
);
